(function () {'use strict';}());
angular.module("app").directive('splashView', function($document,$timeout,$rootScope) {
    return {
      restrict: 'A',
      templateUrl: 'views/splash.html',

      link:function($scope,element,attr)
      {
        var trace = angular.trace;

        $scope.launching = false;

        $scope.launch = function(){
          var evt = {
                eventCategory: "GRTT: Game",
                eventLabel:  "GRTT: game"
            };
          gtag("event", "GRTT: start", evt);
        	$scope.launching = true;
        	$timeout(launch,500);
        };
              $rootScope.$watch("audioOn",onAudioStateChange);

        $scope.toggleVolume = function(){
            $rootScope.audioOn = !$rootScope.audioOn;
        };

        function onAudioStateChange(value){
          $scope.audioOn = $rootScope.audioOn;
        } 

        function launch(){
        	$scope.setCurrentPage($scope.PAGE_LANDING);
        }
      }  
    };
  });